import { Component } from '@angular/core';
import { NavComponent } from '../nav/nav.component';
import { BodyComponent } from '../body/body.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [NavComponent, BodyComponent, FooterComponent],
  template: `
    <app-nav></app-nav>
    <app-body></app-body>
    <app-footer></app-footer>
  `,
})
export class ShellComponent {}
